import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { CartProvider } from "@/lib/cart";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { FeaturedProducts } from "@/components/landing/FeaturedProducts";
import { ShopPreview } from "@/components/landing/ShopPreview";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { Testimonials } from "@/components/landing/Testimonials";
import { Gallery } from "@/components/landing/Gallery";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
// Admin (CRM)
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import Customers from "@/admin/Customers";
import CustomerDetail from "@/admin/CustomerDetail";
import Layaways from "@/admin/Layaways";
import LayawayDetail from "@/admin/LayawayDetail";
// Admin (Inventory + Orders)
import ScanProduct from "@/admin/ScanProduct";
import AdminProducts from "@/admin/AdminProducts";
import AdminProductForm from "@/admin/AdminProductForm";
import InventoryDashboard from "@/admin/InventoryDashboard";
import { AdminOrders, AdminOrderDetail } from "@/admin/AdminOrders";
// Shop
import { ShopNavbar } from "@/shop/ShopNavbar";
import ShopHome from "@/shop/ShopHome";
import ProductPage from "@/shop/ProductPage";
import CartPage from "@/shop/CartPage";
import CheckoutPage from "@/shop/CheckoutPage";
import AccountPage from "@/shop/AccountPage";
import WishlistPage from "@/shop/WishlistPage";
import { AboutPage, ShippingPage, ReturnsPage } from "@/shop/StaticPages";

const Landing = () => (
  <SmoothScroll>
    <div className="bg-[#0A0908] min-h-screen">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <FeaturedProducts />
        <ShopPreview />
        <Marquee />
        <Manifesto />
        <Testimonials />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  </SmoothScroll>
);

const ShopLayout = ({ children }) => (
  <div className="bg-[#0A0908] min-h-screen flex flex-col">
    <ShopNavbar />
    <div className="flex-1">{children}</div>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: { background: "#1F1A17", color: "#F5F0E6", border: "1px solid rgba(200,155,60,0.3)" },
        }}
      />
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            {/* Shop (public) */}
            <Route path="/shop" element={<ShopLayout><ShopHome /></ShopLayout>} />
            <Route path="/shop/new" element={<ShopLayout><ShopHome initialFilter={{ new_arrival: true }} /></ShopLayout>} />
            <Route path="/shop/sale" element={<ShopLayout><ShopHome initialFilter={{ on_sale: true }} /></ShopLayout>} />
            <Route path="/shop/featured" element={<ShopLayout><ShopHome initialFilter={{ featured: true }} /></ShopLayout>} />
            <Route path="/shop/product/:slug" element={<ShopLayout><ProductPage /></ShopLayout>} />
            <Route path="/shop/cart" element={<ShopLayout><CartPage /></ShopLayout>} />
            <Route path="/shop/checkout" element={<ShopLayout><CheckoutPage /></ShopLayout>} />
            <Route path="/shop/account" element={<ShopLayout><AccountPage /></ShopLayout>} />
            <Route path="/shop/wishlist" element={<ShopLayout><WishlistPage /></ShopLayout>} />
            {/* Static */}
            <Route path="/pages/about" element={<ShopLayout><AboutPage /></ShopLayout>} />
            <Route path="/pages/shipping" element={<ShopLayout><ShippingPage /></ShopLayout>} />
            <Route path="/pages/returns" element={<ShopLayout><ReturnsPage /></ShopLayout>} />
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="scan" element={<ScanProduct />} />
              <Route path="inventory" element={<InventoryDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="products/new" element={<AdminProductForm />} />
              <Route path="products/:id" element={<AdminProductForm />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="orders/:id" element={<AdminOrderDetail />} />
              <Route path="customers" element={<Customers />} />
              <Route path="customers/:id" element={<CustomerDetail />} />
              <Route path="layaways" element={<Layaways />} />
              <Route path="layaways/:id" element={<LayawayDetail />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
